import { createAnatomy } from '@zag-js/anatomy';

const anatomy = createAnatomy("fieldset").parts("root", "errorText", "helperText", "legend");

export { anatomy };
